import React from 'react';

type Props = {
  elementId: string;
  containerRef: React.RefObject<HTMLDivElement> | null;
  scrollOffset?: number;
  scrollBehavior?: 'auto' | 'smooth';
};
/**
 * @deprecated Use useScrollIntoView instead
 * @param elementId
 * @param containerRef
 * @param scrollOffset
 * @param scrollBehavior
 */
export const scrollIntoView = ({ elementId, containerRef, scrollOffset, scrollBehavior }: Props) => {
  const element = document.getElementById(elementId);

  setTimeout(() => {
    if (element) {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const elementHeight = element.offsetHeight;
      const offsetTop = element.offsetTop;
      const scrollPosition = Math.max(offsetTop - (windowHeight - elementHeight) / 2, 0);

      containerRef?.current?.scrollTo({ top: scrollPosition, behavior: scrollBehavior || 'auto' });
    }
  }, scrollOffset || 0);
};
